export default "__VITE_ASSET__BT2$qDy0__"